import MobileFileBrowserChrome from '@/wap/components/MobileFileBrowserChrome.vue'
import { classifyMobileTouchGesture } from '@/utils/mobileTouchGesture'

const MOBILE_FILE_MENU_ICON = require('@/assets/wap/recent-sort.png')

export default {
  components: { MobileFileBrowserChrome },
  data() {
    return {
      mobileFileTouchTimer: null,
      mobileFileLongPressResetTimer: null,
      mobileFileTouchStartPoint: null,
      mobileFileTouchStartTime: 0,
      mobileFileTouchStartItemId: '',
      mobileFileTouchMoved: false,
      mobileFileLongPressTriggered: false,
      mobileFileTouchSelectionMode: '',
      mobileFileTouchSelectionActive: false,
      mobileFileTouchGestureType: 'pending'
    }
  },
  watch: {
    detailMode: {
      immediate: true,
      handler(value) {
        this.$emit('detail-mode-change', !!value)
        if (value) {
          this.closeMobileFileBrowserSheets()
        }
      }
    },
    hasPaperSelection: {
      immediate: true,
      handler(value) {
        this.$emit('selection-mode-change', !!value)
      }
    }
  },
  beforeDestroy() {
    this.cancelMobileFileTouch()
  },
  computed: {
    mobileFileBrowserConfig() {
      return this.$options.mobileFileBrowserConfig || {}
    },
    mobileFileBrowserTitle() {
      const currentFolderTitle = this.getMobileFileBrowserCurrentFolderTitle()
      if (currentFolderTitle) {
        return currentFolderTitle
      }
      const configured = this.resolveMobileFileBrowserConfigValue(this.mobileFileBrowserConfig.title)
      return String(configured || '').trim()
    },
    mobileFileBrowserRootLevel() {
      if (typeof this.isPaperRootLevel == 'boolean') {
        return this.isPaperRootLevel
      }
      const path = Array.isArray(this.paperFolderPath) ? this.paperFolderPath : []
      return !this.paperListResourceId && path.length == 0
    },
    mobileFileBrowserCanImport() {
      return this.resolveMobileFileBrowserMode(this.mobileFileBrowserConfig.importMode, false)
    },
    mobileFileBrowserImportLabel() {
      return this.cloudUploadButtonText || (this.ui && (this.ui.importPdf || this.ui.importBooks || this.ui.upload)) || ''
    },
    mobileFileBrowserShowFilter() {
      return this.resolveMobileFileBrowserMode(this.mobileFileBrowserConfig.filterMode, false)
    },
    mobileFileBrowserFilterKey() {
      return this.effectivePaperFilter || this.paperFilter || ''
    },
    mobileFileBrowserShowSort() {
      return this.resolveMobileFileBrowserMode(this.mobileFileBrowserConfig.sortMode, true)
    },
    mobileFileBrowserSortKey() {
      return this.effectiveSortField || this.sortField || 'createTime'
    },
    mobileFileBrowserIcons() {
      const icons = this.paperIcons || {}
      return Object.assign({}, icons, {
        add: icons.add || icons.zoomIn || icons.createFolder || '',
        search: icons.search || '',
        menu: icons.menu || MOBILE_FILE_MENU_ICON,
        check: icons.check || '',
        sortDesc: icons.sortDesc || '',
        sortAsc: icons.sortAsc || '',
        import: icons.import || '',
        createFolder: icons.createFolder || '',
        download: icons.download || ''
      })
    },
    mobileFileBrowserFilterOptions() {
      return Array.isArray(this.filterOptions) ? this.filterOptions : []
    },
    mobileFileBrowserSortOptions() {
      return Array.isArray(this.sortOptions) ? this.sortOptions : []
    },
    mobileFileBrowserProps() {
      return {
        title: this.mobileFileBrowserTitle,
        language: this.language || 'us',
        canImport: this.mobileFileBrowserCanImport,
        importLabel: this.mobileFileBrowserImportLabel,
        showFilter: this.mobileFileBrowserShowFilter,
        filterOptions: this.mobileFileBrowserFilterOptions,
        filterKey: this.mobileFileBrowserFilterKey,
        showSort: this.mobileFileBrowserShowSort,
        sortOptions: this.mobileFileBrowserSortOptions,
        sortKey: this.mobileFileBrowserSortKey,
        sortDesc: this.sortDesc !== false,
        viewMode: this.viewMode == 'grid' ? 'grid' : 'list',
        icons: this.mobileFileBrowserIcons
      }
    },
    mobileFileItemActionItem() {
      const id = this.moreMenuId
      if (id === undefined || id === null || id === '') {
        return null
      }
      const items = Array.isArray(this.visiblePaperItems) ? this.visiblePaperItems : []
      return items.find(item => String(this.getMobileFileItemId(item)) == String(id)) || null
    }
  },
  methods: {
    getMobileFileBrowserCurrentFolderTitle() {
      const path = Array.isArray(this.paperFolderPath) ? this.paperFolderPath : []
      if (path.length == 0) {
        return ''
      }
      const folderPath = typeof this.normalizeCloudPaperFolderPath == 'function'
        ? this.normalizeCloudPaperFolderPath(path)
        : path
      const folder = folderPath[folderPath.length - 1]
      if (!folder || typeof folder != 'object') {
        return ''
      }
      const displayName = typeof this.getPaperDisplayName == 'function'
        ? String(this.getPaperDisplayName(folder) || '').trim()
        : ''
      if (displayName) {
        return displayName
      }
      const keys = ['name', 'title', 'fileName', 'resourceName', 'paperName', 'folderName', 'label', 'displayName']
      for (let index = 0; index < keys.length; index += 1) {
        const value = folder[keys[index]]
        if (value !== undefined && value !== null) {
          const title = String(value).trim()
          if (title) {
            return title
          }
        }
      }
      return ''
    },
    resolveMobileFileBrowserConfigValue(value) {
      return typeof value == 'function' ? value.call(this, this) : value
    },
    resolveMobileFileBrowserMode(mode, fallback = false) {
      const value = this.resolveMobileFileBrowserConfigValue(mode)
      if (typeof value == 'boolean') {
        return value
      }
      const key = String(value || '').trim()
      if (!key) {
        return fallback
      }
      if (key == 'always') {
        return true
      }
      if (key == 'none' || key == 'never') {
        return false
      }
      if (key == 'root') {
        return this.mobileFileBrowserRootLevel
      }
      if (key == 'nonRoot' || key == 'folder') {
        return !this.mobileFileBrowserRootLevel
      }
      if (key == 'template') {
        return !!this.cloudUploadIsTemplateFolder
      }
      return key in this ? !!this[key] : fallback
    },
    closeMobileFileBrowserSheets() {
      const chrome = this.$refs && this.$refs.mobileFileBrowserChrome
      if (chrome && typeof chrome.closeSheets == 'function') {
        chrome.closeSheets()
      }
    },
    handleMobileFileBrowserBack() {
      this.closeMobileFileBrowserSheets()
      const path = Array.isArray(this.paperFolderPath) ? this.paperFolderPath : []
      if (path.length > 0 && typeof this.openPaperBreadcrumb == 'function') {
        this.openPaperBreadcrumb(path.length - 1)
        return
      }
      if (this.paperListResourceId) {
        if (typeof this.resetPaperListTransientState == 'function') {
          this.resetPaperListTransientState()
        }
        this.paperListResourceId = ''
        this.paperFolderPath = []
        if (typeof this.loadPaperList == 'function') {
          this.loadPaperList()
        }
        return
      }
      this.$emit('back-root')
    },
    handleMobileFileBrowserSearch() {
      this.closeMobileFileBrowserSheets()
      this.$emit('global-search')
    },
    handleMobileFileBrowserImport() {
      this.closeMobileFileBrowserSheets()
      if (typeof this.openCloudUploadDialog == 'function') {
        this.openCloudUploadDialog()
      }
    },
    handleMobileFileBrowserFilter(key) {
      this.closeMobileFileBrowserSheets()
      if (typeof this.selectFilter == 'function') {
        this.selectFilter(key)
      }
    },
    handleMobileFileBrowserSort(key) {
      const options = Array.isArray(this.sortOptions) ? this.sortOptions : []
      if (!options.some(item => item && item.key == key)) {
        return
      }
      const sameField = this.mobileFileBrowserSortKey == key
      this.sortField = key
      this.sortDesc = sameField ? !this.sortDesc : true
      this.sortMenuOpen = false
      this.moreMenuId = ''
      this.closeMobileFileBrowserSheets()
      if (typeof this.loadPaperList == 'function') {
        this.loadPaperList()
      }
    },
    handleMobileFileBrowserView(mode) {
      const viewMode = mode == 'grid' ? 'grid' : 'list'
      this.closeMobileFileBrowserSheets()
      if (typeof this.setViewMode == 'function') {
        this.setViewMode(viewMode)
      } else {
        this.viewMode = viewMode
      }
    },
    toggleMobileFileItemAction(item) {
      const id = this.getMobileFileItemId(item)
      if (id === '') {
        this.moreMenuId = ''
        return
      }
      const nextId = String(this.moreMenuId) == String(id) ? '' : id
      if (nextId !== '' && Array.isArray(this.selectedPaperIds) && this.selectedPaperIds.length > 0) {
        this.clearMobileFileSelection()
      }
      this.moreMenuId = nextId
      this.filterMenuOpen = false
      this.sortMenuOpen = false
      this.closeMobileFileBrowserSheets()
    },
    closeMobileFileItemAction() {
      this.moreMenuId = ''
    },
    canUseMobileFileSelection() {
      if ('canUsePaperListSelection' in this && this.canUsePaperListSelection === false) {
        return false
      }
      if ('canSelectPaperItems' in this && this.canSelectPaperItems === false) {
        return false
      }
      return Array.isArray(this.selectedPaperIds)
    },
    getMobileFileItemId(item) {
      if (!item) {
        return ''
      }
      const id = item.id !== undefined && item.id !== null ? item.id : item.resourceId
      return id === undefined || id === null ? '' : id
    },
    clearMobileFileSelection() {
      if (typeof this.clearSelection == 'function') {
        this.clearSelection()
        return
      }
      this.selectedPaperIds = []
      this.selectedPaperId = ''
      this.selectedPaperAnchorId = ''
    },
    startMobileFileSelectionFromItem(item, preserveExisting = true) {
      if (!this.canUseMobileFileSelection()) {
        return
      }
      const id = this.getMobileFileItemId(item)
      if (id === '') {
        return
      }
      let selectedIds = preserveExisting ? this.selectedPaperIds.slice() : []
      const selectedIndex = selectedIds.findIndex(value => String(value) == String(id))
      if (preserveExisting && selectedIndex >= 0) {
        selectedIds.splice(selectedIndex, 1)
      } else if (selectedIndex < 0) {
        selectedIds.push(id)
      }
      this.selectedPaperIds = selectedIds
      this.selectedPaperId = selectedIds[0] || ''
      this.selectedPaperAnchorId = selectedIndex >= 0 ? (selectedIds[0] || '') : id
      this.moreMenuId = ''
      this.filterMenuOpen = false
      this.sortMenuOpen = false
      this.closeMobileFileBrowserSheets()
      if (selectedIds.length == 0 && typeof this.resetSelectionBarOffset == 'function') {
        this.resetSelectionBarOffset()
      }
    },
    isMobileFileItemSelected(itemOrId) {
      const id = itemOrId && typeof itemOrId == 'object'
        ? this.getMobileFileItemId(itemOrId)
        : itemOrId
      return id !== undefined
        && id !== null
        && id !== ''
        && Array.isArray(this.selectedPaperIds)
        && this.selectedPaperIds.some(selectedId => String(selectedId) == String(id))
    },
    setMobileFileTouchItemSelection(item, selected) {
      const id = this.getMobileFileItemId(item)
      if (id === '') {
        return
      }
      const currentIds = Array.isArray(this.selectedPaperIds) ? this.selectedPaperIds.slice() : []
      const selectedIndex = currentIds.findIndex(selectedId => String(selectedId) == String(id))
      if (selected && selectedIndex < 0) {
        currentIds.push(id)
      } else if (!selected && selectedIndex >= 0) {
        currentIds.splice(selectedIndex, 1)
      }
      this.selectedPaperIds = currentIds
      this.selectedPaperId = currentIds[0] || ''
      this.selectedPaperAnchorId = currentIds.length > 0 ? id : ''
      this.moreMenuId = ''
      this.filterMenuOpen = false
      this.sortMenuOpen = false
      this.closeMobileFileBrowserSheets()
      if (currentIds.length == 0 && typeof this.resetSelectionBarOffset == 'function') {
        this.resetSelectionBarOffset()
      }
    },
    applyMobileFileTouchSelection(item, mode = this.mobileFileTouchSelectionMode) {
      this.setMobileFileTouchItemSelection(item, mode != 'deselect')
    },
    startMobileFileTouch(item, event) {
      this.clearMobileFileTouchTimer()
      this.clearMobileFileLongPressResetTimer()
      this.mobileFileTouchMoved = false
      this.mobileFileLongPressTriggered = false
      this.mobileFileTouchSelectionActive = false
      this.mobileFileTouchSelectionMode = ''
      this.mobileFileTouchGestureType = 'pending'
      const touch = event && event.touches && event.touches[0]
      this.mobileFileTouchStartPoint = touch ? { x: touch.clientX, y: touch.clientY } : null
      this.mobileFileTouchStartTime = Date.now()
      this.mobileFileTouchStartItemId = this.getMobileFileItemId(item)
      if (!item || !this.canUseMobileFileSelection() || typeof window === 'undefined') {
        return
      }
      this.mobileFileTouchSelectionMode = this.isMobileFileItemSelected(item) ? 'deselect' : 'select'
      this.mobileFileTouchTimer = window.setTimeout(() => {
        this.mobileFileTouchTimer = null
        this.mobileFileLongPressTriggered = true
        this.mobileFileTouchSelectionActive = true
        this.mobileFileTouchGestureType = 'selection'
        if (typeof this.cancelMobilePullRefreshGesture == 'function') {
          this.cancelMobilePullRefreshGesture()
        }
        this.applyMobileFileTouchSelection(item)
      }, 520)
    },
    moveMobileFileTouch(event) {
      const touch = event && event.touches && event.touches[0]
      if (!touch) {
        return
      }
      const start = this.mobileFileTouchStartPoint
      if (!start) {
        return
      }
      const gestureType = classifyMobileTouchGesture({
        startX: start.x,
        startY: start.y,
        startTime: this.mobileFileTouchStartTime,
        gestureType: this.mobileFileTouchGestureType,
        longPressTriggered: this.mobileFileLongPressTriggered
      }, touch)
      if (gestureType == 'pending') {
        return
      }
      this.mobileFileTouchGestureType = gestureType
      this.mobileFileTouchMoved = true
      this.clearMobileFileTouchTimer()
      if (gestureType != 'selection') {
        return
      }
      if (!this.mobileFileLongPressTriggered) {
        if (this.selectedPaperIds.length == 0) {
          return
        }
        this.mobileFileLongPressTriggered = true
        this.mobileFileTouchSelectionActive = true
        if (typeof this.cancelMobilePullRefreshGesture == 'function') {
          this.cancelMobilePullRefreshGesture()
        }
        const items = Array.isArray(this.visiblePaperItems) ? this.visiblePaperItems : []
        const startItem = items.find(candidate => String(this.getMobileFileItemId(candidate)) == String(this.mobileFileTouchStartItemId))
        if (startItem) {
          this.applyMobileFileTouchSelection(startItem)
        }
      }
      if (event.cancelable) {
        event.preventDefault()
      }
      this.extendMobileFileTouchSelection(touch.clientX, touch.clientY)
    },
    endMobileFileTouch() {
      this.clearMobileFileTouchTimer()
      this.mobileFileTouchStartPoint = null
      this.mobileFileTouchStartTime = 0
      this.mobileFileTouchStartItemId = ''
      if ((this.mobileFileLongPressTriggered || this.mobileFileTouchMoved) && typeof window !== 'undefined') {
        const moved = this.mobileFileTouchMoved
        this.mobileFileLongPressResetTimer = window.setTimeout(() => {
          this.mobileFileLongPressResetTimer = null
          this.mobileFileLongPressTriggered = false
          this.mobileFileTouchSelectionActive = false
          this.mobileFileTouchSelectionMode = ''
          this.mobileFileTouchGestureType = 'pending'
          if (moved) {
            this.mobileFileTouchMoved = false
          }
        }, 350)
      }
    },
    cancelMobileFileTouch() {
      this.clearMobileFileTouchTimer()
      this.clearMobileFileLongPressResetTimer()
      this.mobileFileTouchStartPoint = null
      this.mobileFileTouchStartTime = 0
      this.mobileFileTouchStartItemId = ''
      this.mobileFileTouchMoved = false
      this.mobileFileLongPressTriggered = false
      this.mobileFileTouchSelectionMode = ''
      this.mobileFileTouchSelectionActive = false
      this.mobileFileTouchGestureType = 'pending'
    },
    clearMobileFileTouchTimer() {
      if (this.mobileFileTouchTimer) {
        clearTimeout(this.mobileFileTouchTimer)
        this.mobileFileTouchTimer = null
      }
    },
    clearMobileFileLongPressResetTimer() {
      if (this.mobileFileLongPressResetTimer) {
        clearTimeout(this.mobileFileLongPressResetTimer)
        this.mobileFileLongPressResetTimer = null
      }
    },
    extendMobileFileTouchSelection(clientX, clientY) {
      if (typeof document === 'undefined' || typeof document.elementFromPoint != 'function') {
        return
      }
      const element = document.elementFromPoint(clientX, clientY)
      const row = element && element.closest ? element.closest('[data-mobile-file-id]') : null
      const id = row && row.getAttribute('data-mobile-file-id')
      const items = Array.isArray(this.visiblePaperItems) ? this.visiblePaperItems : []
      const item = id === null ? null : items.find(candidate => String(this.getMobileFileItemId(candidate)) == String(id))
      if (!item) {
        return
      }
      const startIndex = items.findIndex(candidate => String(this.getMobileFileItemId(candidate)) == String(this.mobileFileTouchStartItemId))
      const endIndex = items.indexOf(item)
      const crossedItems = startIndex >= 0 && endIndex >= 0
        ? items.slice(Math.min(startIndex, endIndex), Math.max(startIndex, endIndex) + 1)
        : [item]
      const shouldSelect = this.mobileFileTouchSelectionMode != 'deselect'
      const selectedIds = (Array.isArray(this.selectedPaperIds) ? this.selectedPaperIds : []).slice()
      const selectedSet = new Set(selectedIds.map(value => String(value)))
      crossedItems.forEach(candidate => {
        const candidateId = this.getMobileFileItemId(candidate)
        if (candidateId === '') {
          return
        }
        if (shouldSelect) {
          if (!selectedSet.has(String(candidateId))) {
            selectedIds.push(candidateId)
            selectedSet.add(String(candidateId))
          }
        } else if (selectedSet.has(String(candidateId))) {
          const selectedIndex = selectedIds.findIndex(value => String(value) == String(candidateId))
          if (selectedIndex >= 0) {
            selectedIds.splice(selectedIndex, 1)
          }
          selectedSet.delete(String(candidateId))
        }
      })
      this.selectedPaperIds = selectedIds
      this.selectedPaperId = selectedIds[0] || ''
      this.selectedPaperAnchorId = this.getMobileFileItemId(item)
      this.moreMenuId = ''
      if (selectedIds.length == 0 && typeof this.resetSelectionBarOffset == 'function') {
        this.resetSelectionBarOffset()
      }
    },
    handleMobileFileContextMenu(item, event) {
      if (event && typeof event.preventDefault == 'function') {
        event.preventDefault()
      }
      this.clearMobileFileTouchTimer()
      if (!item || this.mobileFileLongPressTriggered || this.mobileFileTouchMoved || !this.canUseMobileFileSelection()) {
        return
      }
      this.mobileFileLongPressTriggered = true
      this.mobileFileTouchSelectionActive = true
      this.mobileFileTouchGestureType = 'selection'
      this.mobileFileTouchSelectionMode = this.mobileFileTouchSelectionMode || (this.isMobileFileItemSelected(item) ? 'deselect' : 'select')
      if (typeof this.cancelMobilePullRefreshGesture == 'function') {
        this.cancelMobilePullRefreshGesture()
      }
      this.applyMobileFileTouchSelection(item)
    },
    openMobileFileItem(item, event) {
      if (!item) {
        return
      }
      if (typeof this.clearPaperItemClickTimer == 'function') {
        this.clearPaperItemClickTimer()
      }
      const opensFolder = typeof this.canOpenPaperResourceFolder == 'function' && this.canOpenPaperResourceFolder(item)
      if (typeof this.activatePaperListItem == 'function') {
        this.activatePaperListItem(item, event)
        if (opensFolder && typeof this.scrollMobileCloudListToTop == 'function') {
          this.scrollMobileCloudListToTop()
        }
        return
      }
      if (opensFolder && typeof this.openPaperResourceFolder == 'function') {
        this.openPaperResourceFolder(item)
        if (typeof this.scrollMobileCloudListToTop == 'function') {
          this.scrollMobileCloudListToTop()
        }
        return
      }
      if (typeof this.openPaperItem == 'function') {
        this.openPaperItem(item, event)
      }
    },
    handleMobileFileItemClick(item, event) {
      if (!item) {
        return
      }
      if (event && event.detail > 1) {
        return
      }
      if (this.mobileFileTouchMoved) {
        this.clearMobileFileLongPressResetTimer()
        this.mobileFileTouchMoved = false
        this.mobileFileLongPressTriggered = false
        this.mobileFileTouchSelectionActive = false
        this.mobileFileTouchSelectionMode = ''
        this.mobileFileTouchGestureType = 'pending'
        return
      }
      if (this.mobileFileLongPressTriggered) {
        this.clearMobileFileLongPressResetTimer()
        this.mobileFileLongPressTriggered = false
        this.mobileFileTouchSelectionActive = false
        this.mobileFileTouchSelectionMode = ''
        this.mobileFileTouchGestureType = 'pending'
        return
      }
      if (Array.isArray(this.selectedPaperIds) && this.selectedPaperIds.length > 0) {
        this.startMobileFileSelectionFromItem(item, true)
        return
      }
      this.closeMobileFileBrowserSheets()
      this.openMobileFileItem(item, event)
    },
    handleMobileFileItemDblClick(item, event) {
      if (event && typeof event.preventDefault == 'function') {
        event.preventDefault()
      }
      this.openMobileFileItem(item, event)
    },
    handleMobileFileItemKeyup(item, event) {
      if (!item || (event && event.repeat)) {
        return
      }
      this.clearMobileFileSelection()
      this.openMobileFileItem(item, event)
    }
  }
}
